import React, { useState, useEffect } from 'react';
import FieldText from '../../../../../components/FieldText/FieldText';
import FieldDate from '../../../../../components/FieldDate/FieldDate';
import { API } from '../../../../../API/API';
import { Panel, PanelType } from '@fluentui/react';
import ButtonSecondary from '../../../../../components/ButtonSecondary/ButtonSecondary';
import { message } from 'antd';
import { MessageConst } from '../../../../../const/MessageConst';
import Warning from '../../../../../components/Warning/Warning';
import FieldItemList from '../../../../../components/FieldItemList/FieldItemList';
import ButtonDefaultWithLoad from '../../../../../components/ButtonDefaultWithLoad/ButtonDefaultWithLoad';
import ButtonSecondaryWithLoad from '../../../../../components/ButtonSecondaryWithLoad/ButtonSecondaryWithLoad';

const MaritalStatus = (props) => {

    const [initData] = useState({
        "entryid": -1,
        "empid": props.empid,
        "relativeid": null,
        "lastname": null,
        "firstname": null,
        "divisionid": null,
        "districtid": null,
        "birthdate": null,
        "famregno": null,
        "relativename": null,
        "countryid": null
    })
    const [data, setData] = useState({ ...initData });
    const [warning, setWarning] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);

    const getExistData = async () => {
        let tData = { ...initData };
        if (props.entryid) {
            setLoading(true);
            await API.get('/api/humanresource/employee/get_empfamily?entryid=' + props.entryid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data?.retdata?.length > 0) {
                        tData = response.data.retdata[0];
                    }
                }
            });
            setLoading(false);
        }
        setData(tData);
    }

    useEffect(() => {
        getExistData();
    }, [props.entryid]);

    const fieldOnChanged = async (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }
            if (field == 'countryid') {
                tData.divisionid = null;
                tData.districtid = null;
            }

            if (field == 'divisionid') {
                tData.districtid = null;
            }
            setData(tData);

        }
    }

    const onSave = async (p_close) => {

        let vRule = true;
        if (!data.relativeid) {
            vRule = false;
            setWarning("Хэн болох" + MessageConst.fieldRequired);
        } else if (!data.lastname) {
            vRule = false;
            setWarning("Эцэг/эх/-ийн нэр" + MessageConst.fieldRequired);
        } else if (!data.firstname) {
            vRule = false;
            setWarning("Нэр" + MessageConst.fieldRequired);
        }

        if (vRule) {
            setLoadingSave(true);
            let tData = { ...data };
            tData.empid = props.empid;
            await API.post('/api/humanresource/employee/save_empfamily', [tData]).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    setData({ ...initData });
                    setWarning();
                    if (props.afterSave) {
                        props.afterSave(p_close);
                    }
                }
            });
            setLoadingSave(false);
        }
    }

    const onDelete = async (p_close) => {
        await API.post('/api/humanresource/employee/delete_empfamily?entryid=' + props.entryid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                setData({ ...initData });
                message.success(MessageConst.success);
                clearData();
                if (props.afterSave) {
                    props.afterSave(p_close);
                }
            }
        });
    }

    const onDismiss = () => {
        clearData();
        props.onDismiss();
    }

    const clearData = () => {
        setData({ ...initData });
        setWarning();
    }

    return (
        <Panel
            headerText={props.entryid > 0 ? "Гэрийн бүлийн гишүүн засах" : "Гэрийн бүлийн гишүүн нэмэх"}
            isOpen={props.onOpen}
            type={PanelType.medium}
            isFooterAtBottom={true}
            onDismiss={onDismiss}
            onRenderFooterContent={() => (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Warning zeroMargin value={warning} />
                    {props.entryid > 0 ? (
                        <div>
                            <ButtonSecondary onClick={() => onDelete(true)} text="Устгах" />
                        </div>) : null}
                    <div style={{ marginLeft: 16 }}>
                        <ButtonSecondaryWithLoad loading={loadingSave} onClick={() => onSave(false)} text="Хадгалаад шинэ" />
                    </div>
                    <div style={{ marginLeft: 16 }}>
                        <ButtonDefaultWithLoad loading={loadingSave} onClick={() => onSave(true)} text="Хадгалах" />
                    </div>
                </div>
            )}
        >
            <div style={{ marginTop: 20 }}>
                <FieldItemList required loading={loading} title="Хэн болох" onChanged={fieldOnChanged} keyfield='relativeid' keyfieldname='relativename' defaultValue={[{ key: data.relativeid, name: data.relativename }]} dataurl="/api/humanresource/organization/get_relative_dropdown" />
                <div style={{ marginTop: 13 }}>
                    <FieldText loading={loading} title="Эцэг/эх/-ийн нэр" onChanged={fieldOnChanged} keyfield='lastname' defaultValue={data.lastname} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldText required loading={loading} title="Нэр" onChanged={fieldOnChanged} keyfield='firstname' defaultValue={data.firstname} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDate loading={loading} title="Төрсөн огноо" onChanged={fieldOnChanged} keyfield='birthdate' defaultValue={data.birthdate} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldText loading={loading} title="Регистрийн дугаар" onChanged={fieldOnChanged} keyfield='famregno' defaultValue={data.famregno} />
                </div>
            </div>
        </Panel>

    );
}

export default MaritalStatus;